import { render, staticRenderFns } from "./JiraTodos.vue?vue&type=template&id=6c7f7c9e&"
import script from "./JiraTodos.vue?vue&type=script&lang=js&"
export * from "./JiraTodos.vue?vue&type=script&lang=js&"
import style0 from "./JiraTodos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports